import React from 'react';
import { observer } from 'mobx-react-lite';

import { useLocationSettings } from './location-settings.hooks';
import { LocationSettingsPopoverDark } from './location-settings-popover-dark';
import { LocationSettingsControllerProps } from './location-settings-popover.types';

export const LocationSettingsControllerDark = observer(
  ({ onSave, anchorEl }: LocationSettingsControllerProps): JSX.Element => (
    <LocationSettingsPopoverDark anchorEl={anchorEl} {...useLocationSettings({ onSave })} />
  )
);
